/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';
import { NavbarComponent } from '../../../navbar/navbar.component';

@Component({
	selector: 'app-treatment-costs',
	templateUrl: './treatment-costs.component.html',
	styleUrl: './treatment-costs.component.scss'
})
export class TreatmentCostsComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/treatment-costs",
			name: "Quotations"
		}
	];

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	dtOptions: Config = {};
	dataList: any = [];
	showDeleteLoader: any = null;
	pagetitle = "Quotations";
	pageLoading = false;
	stateList: any[] = [];
	cityList: any[] = [];
	hospitalList: any[] = [];
	filters: any = {
		state: null,
		city: null,
		hospital: null
	};

	constructor(private apiService: ApiService, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	ngOnInit(): void {
		this.initDatatable();
		this.getStatesByCountry();
		this.getHospitalList();
	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			ajax: (dataTablesParameters: any, callback) => {
				const data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					searchVal: dataTablesParameters.search.value
				}
				if (this.filters.state) {
					data["state"] = this.filters.state;
				}
				if (this.filters.city) {
					data["city"] = this.filters.city;
				}
				if (this.filters.hospital) {
					data["hospital"] = this.filters.hospital;
				}
				this.apiService.getTreatmentCosts(data).subscribe({
					next: (response: any) => {
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	deleteConfirm(uId: any) {
		Swal.fire({
			title: 'Warning',
			html: 'Are you sure you want to delete record?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoader = uId;
				this.apiService.deleteTreatmentCosts(uId).subscribe({
					next: () => {
						this.showDeleteLoader = null;
						Swal.fire('Success', 'Deleted successfully.', 'success');
						this.refreshTable();
					}, error: (error) => {
						this.showDeleteLoader = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	loadingStates = false;
	getStatesByCountry() {
		this.loadingStates = true;
		this.apiService.stateList("IND").subscribe({
			next: (data: any) => {
				this.loadingStates = false;
				this.stateList = [...data];
				if (this.filters.state) {
					if (!this.stateList.find((doc) => doc.stateID == this.filters.state)) {
						this.filters.state = null;
					}
				}
			}, error: () => {
				this.loadingStates = false;
				this.stateList = [];
				this.filters.state = null;
			}
		});
	}

	loadingCities = false;
	getCitiesByState() {
		this.filters.city = null;
		if (this.filters.state) {
			this.loadingCities = true;
			this.apiService.cityList(this.filters.state).subscribe({
				next: (data: any) => {
					this.loadingCities = false;
					this.cityList = [...data];
				}, error: () => {
					this.loadingCities = false;
					this.cityList = [];
				}
			});
		} else {
			this.cityList = [];
		}
	}

	loadingHospitals = false;
	getHospitalList() {
		this.filters.hospital = null;
		this.loadingHospitals = true;
		if (this.filters.city) {
			this.apiService.getHospitalsByCity({ city: this.filters.city }).subscribe({
				next: (data: any) => {
					this.loadingHospitals = false;
					this.hospitalList = [...data.data];
				}, error: () => {
					this.loadingHospitals = false;
					this.hospitalList = [];
				}
			});
		} else {
			this.apiService.getHospital({}).subscribe({
				next: (data: any) => {
					this.loadingHospitals = false;
					this.hospitalList = [...data.data];
				}, error: () => {
					this.loadingHospitals = false;
					this.hospitalList = [];
				}
			});
		}
	}
}
